<div data-aos="fade-up" class="cage-5 package">
    <div [ngClass]="company" class="ct-start-1-1">
        <img [src]="element.img" />
    </div>
    <div class="ct-start-2-4 flex-col">
        <div class="headline_03">{{element.title}}</div>
        <div class="body_02_s_bold" *ngIf="!!element.subtitle"><b>{{element.subtitle}}</b></div>
        <div class="body_03_xl_regular text">{{element.description}}</div>
    </div>
</div>